import React from 'react';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { locations } from '../../mock';

const phoneDigits = (raw) => String(raw || '').replace(/[^\d]/g, '');

const Footer = ({ businessInfo }) => {
  const wa = phoneDigits(businessInfo.phone);
  return (
    <footer className="bg-chocolate-dark pt-12 pb-8 px-6 text-white/70">
      <div className="container mx-auto">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Marca + redes */}
          <div className="space-y-3">
            <div className="text-white font-bold text-xl">{businessInfo.name}</div>
            <div className="text-sm">{businessInfo.tagline}</div>
            <p className="text-sm">Pastelería artesanal en Quito: más de 40 sabores de brazos gitanos, pasteles, galletas y más.</p>
            <div className="flex items-center gap-4 pt-1">
              <a href={businessInfo.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram de Brazolovers" className="hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={businessInfo.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook de Brazolovers" className="hover:text-white transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Navegación (rutas reales → enlaces internos) */}
          <nav className="space-y-2" aria-label="Navegación del pie">
            <div className="text-white font-semibold mb-1">Navegación</div>
            <Link to="/" className="block hover:text-white transition-colors">Inicio</Link>
            <Link to="/menu/" className="block hover:text-white transition-colors">Menú completo</Link>
            <Link to="/nosotros/" className="block hover:text-white transition-colors">Nosotros</Link>
            <Link to="/ubicaciones/" className="block hover:text-white transition-colors">Ubicaciones</Link>
            <Link to="/contacto/" className="block hover:text-white transition-colors">Contacto</Link>
          </nav>

          {/* Productos (anclas a secciones de la home) */}
          <nav className="space-y-2" aria-label="Productos">
            <div className="text-white font-semibold mb-1">Productos</div>
            <a href="/#productos" className="block hover:text-white transition-colors">Brazos Gitanos</a>
            <a href="/#cakes" className="block hover:text-white transition-colors">Pasteles</a>
            <a href="/#galletas" className="block hover:text-white transition-colors">Galletas</a>
            <a href="/#panaderia" className="block hover:text-white transition-colors">Panadería</a>
            <a href="/#desayunos" className="block hover:text-white transition-colors">Desayunos</a>
          </nav>

          {/* Contacto / locales (NAP) */}
          <div className="space-y-2">
            <div className="text-white font-semibold mb-1">Contacto</div>
            {locations.map((loc) => (
              <p key={loc.id} className="flex items-start gap-2 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-caramel" />
                <span><strong className="text-white/90">{loc.name}:</strong> {loc.address}</span>
              </p>
            ))}
            <a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm hover:text-white transition-colors">
              <Phone className="w-4 h-4 shrink-0 text-caramel" /> WhatsApp: +{wa}
            </a>
            <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-2 text-sm hover:text-white transition-colors">
              <Mail className="w-4 h-4 shrink-0 text-caramel" /> {businessInfo.email}
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 text-center text-sm space-y-3">
          {/* Legales: obligatorio tenerlas accesibles desde cualquier página. */}
          <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2" aria-label="Información legal">
            <Link to="/privacidad/" className="hover:text-white transition-colors">Política de Privacidad</Link>
            <span aria-hidden="true" className="opacity-40">·</span>
            <Link to="/terminos/" className="hover:text-white transition-colors">Términos y Condiciones</Link>
          </nav>
          {/* Año fijo a propósito: `new Date().getFullYear()` daría distinto en
              el prerender (build) que en el cliente al cruzar el 1 de enero, y
              eso es un text-content mismatch (React #425) que check-hydration.js
              marca como fallo. Se actualiza a mano una vez al año. */}
          <div>© 2026 Brazolovers. Todos los derechos reservados.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
